import React, { useEffect, useState } from 'react';
import LateralMenu, { Item } from '../LateralMenu';
import { faBug, faClipboardList, faFileSignature, faGear, faSearch, faShield, faCar, faMemoCircleCheck, faMemoCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_app_agent.png';
import collapsedLogo from '../../../assets/icon_app_agent.png';

export default function AppAgentLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu }: LateralMenuProps) {

    const [stateItems, setStateItems] = useState<Item[]>([]);

    async function getItems() {
        const items = [{
            icon: faClipboardList,
            text: translate('occurrences'),
            action: () => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' }),
            selected: selectedMenu == 'occurrences'
        }, {
            icon: faShield,
            text: translate('teams'),
            action: () => navigation.navigate('AppAgent', { screen: 'AgentUnits' }),
            selected: selectedMenu == 'units'
        }];

        if (authenticatedUser?.isAdmin || authenticatedUser?.permissions.search_people_cortex || authenticatedUser?.permissions.search_cortex_any_time) {
            items.push({
                icon: faSearch,
                text: translate('searchOnCortex'),
                action: () => navigation.navigate('AppAgent', { screen: 'CortexFinder' }),
                selected: selectedMenu == 'cortex-finder'
            });
        }

        items.push({
            icon: faFileSignature,
            text: translate('signatures'),
            action: () => navigation.navigate('AppAgent', { screen: 'AgentSignatures' }),
            selected: selectedMenu == 'signatures'
        });

        if (authenticatedUser?.permissions.app_agent_deac_access) {
            items.push({
                icon: faMemoCircleInfo,
                text: translate('openVacancies'),
                action: () => navigation.navigate('AppAgent', { screen: 'OpenVacancies' }),
                selected: selectedMenu == 'open-vacancies'
            }, {
                icon: faMemoCircleCheck,
                text: translate('myCandidacies'),
                action: () => navigation.navigate('AppAgent', { screen: 'Candidacies' }),
                selected: selectedMenu == 'my-candidacies'
            });
        }
        if (window.AndroidBridge) {
            items.push({
                icon: faBug,
                text: translate('debugger'),
                action: () => navigation.navigate('AppAgent', { screen: 'Debugger' }),
                selected: selectedMenu == 'debugger'
            });
            items.push({
                icon: faGear,
                text: translate('services'),
                action: () => navigation.navigate('AppAgent', { screen: 'Services' }),
                selected: selectedMenu == 'services'
            });
            if (authenticatedUser?.permissions.app_agent_manage_services) {
                items.push({
                    icon: faCar,
                    text: translate('lprEvents'),
                    action: () => navigation.navigate('AppAgent', { screen: 'LprEvents' }),
                    selected: selectedMenu == 'lpr-events'
                });
            }
        }
        setStateItems(items);
    }

    useEffect(() => {
        getItems();
    }, [navigation, open, authenticatedUser, setOpen, selectedMenu]);

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={stateItems}
        />
    );
}
